import { render } from "./CatMaterialView.vue?vue&type=template&id=8eaa4bd2&scoped=true"
import script from "./CatMaterialView.vue?vue&type=script&lang=js"
export * from "./CatMaterialView.vue?vue&type=script&lang=js"

import "./CatMaterialView.vue?vue&type=style&index=0&id=8eaa4bd2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eaa4bd2"]])

export default __exports__